import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import About from '../views/About.vue'
import Auth from '../views/Auth.vue'
import ListaEmpleados from '../views/GestionMarcaciones/ListaEmpleados.vue'
import DatosEmpleados from '../views/GestionEmpleados/DatosEmpleados.vue'
import CargaEmpleados from '../views/GestionEmpleados/CargaEmpleados.vue'
import EdicionMasivaEmpleados from '../views/GestionEmpleados/EdicionMasivaEmpleados.vue'
import MarcacionesEmpleado from '../views/GestionMarcaciones/MarcacionesEmpleado.vue'
import CargaMarcaciones from '../views/GestionMarcaciones/CargaMarcaciones.vue'
import BusquedaHorario from '../views/GestionHorarios/BusquedaHorario.vue'
import NuevoHorario from '../views/GestionHorarios/NuevoHorario.vue'
import CopiarHorario from '../views/GestionHorarios/CopiarHorario.vue'
import CambiarHorario from '../views/CambioHorarios/CambiarHorario.vue'
import ReglasMarcacion from '../views/GestionReglasMarcacion/ReglasMarcacion.vue'
import NuevaRegla from '../views/GestionReglasMarcacion/NuevaRegla.vue'
import ClonarNuevaRegla from '../views/GestionReglasMarcacion/ClonarNuevaRegla.vue'
import ReporteMarcacion from '../views/Reportes/ReporteMarcacion.vue'
import App from '../App.vue'


const routes  = [
  

  {
    path: '/app',
    name: 'app',
    component: App,
    children:
    [ 
      {
        path: '/home',
        name: 'home',
        component: Home
      },
      {
        path: '/',
        name: '/',
        component: Home
      },
      {
        path: '/about',
        name: 'about',
        component: About
      },
      {
        path: '/auth',
        name: 'auth',
        component: Auth
      },
      {
        path: '/gestion-empleados',
        name: 'gestion-empleados',
        component: DatosEmpleados
      },
      {
        path: '/lista-empleados',
        name: 'lista-empleados',
        component: ListaEmpleados
      },
      {
        path: '/marcaciones-empleados',
        name: 'marcaciones-empleados',
        component: MarcacionesEmpleado
      },
      {
        path: '/carga-empleados',
        name: 'carga-empleados',
        component: CargaEmpleados
      },
      {
        path: '/carga-marcaciones',
        name: 'carga-marcaciones',
        component: CargaMarcaciones
      },
      {
        path: '/edicion-masiva-empleados',
        name: 'edicion-masiva-empleados',
        component: EdicionMasivaEmpleados
      },
      {
        path: '/busqueda-horarios',
        name: 'busqueda-horarios',
        component: BusquedaHorario
      },
      {
        path: '/nuevo-horario',
        name: 'nuevo-horario',
        component: NuevoHorario
      },
      {
        path: '/copiar-horario',
        name: 'copiar-horario',
        component: CopiarHorario
      },
      {
        path: '/cambiar-horario',
        name: 'cambiar-horario',
        component: CambiarHorario
      },
      {
        path: '/reglas-marcacion',
        name: 'reglas-marcacion',
        component: ReglasMarcacion
      },
      {
        path: '/nueva-regla',
        name: 'nueva-regla',
        component: NuevaRegla
      },
      {
        path: '/clonar-nueva-regla',
        name: 'clonar-nueva-regla',
        component: ClonarNuevaRegla
      },
      {
        path: '/reporte-marcacion',
        name: 'reporte-marcacion',
        component: ReporteMarcacion
      },


      
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
